"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createAction = _interopRequireDefault(require("./createAction"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = (0, _createAction["default"])('Batch', function () {
  for (var _len = arguments.length, actions = new Array(_len), _key = 0; _key < _len; _key++) {
    actions[_key] = arguments[_key];
  }

  if (actions.length === 1 && Array.isArray(actions[0])) {
    return actions[0];
  }

  return actions;
});

exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/redux-act/lib/batch.js
// module id = 284
// module chunks = 0